import flagsmith from '@flagsmith/flagsmith';
import { FLAGSMITH_KEYS } from './key';

export const OLD_SEQUENCE_ID = '78f98a3d-1f7e-4709-8e39-b5850af70e24';
export const NEW_SEQUENCE_ID = 'fa878f82-ca29-4dcc-af64-0bf6d3bd7853';

export function getSequenceId(): string {
  const flags = flagsmith.getAllFlags();
  const f = flags?.[FLAGSMITH_KEYS.SHOW_NEW_FEATURE_V1];

  if (f?.enabled && f?.value === true) return NEW_SEQUENCE_ID;

  return OLD_SEQUENCE_ID;
}
